<div class="occupancy-info">
    <div 
        class="d-flex align-items-center gap-1" 
    >
        <tui-icon icon="/assets/svg/adultes.svg" class="adultes"></tui-icon>
        <span class="adultes-count">x{{bestPrice().code_occupancy}}</span>
        @if (bestPrice().code_children) {
            <span class="child">
                +
            </span>
            <span class="child">
                <tui-icon icon="/assets/svg/child.svg"></tui-icon>
            </span>
        }
        @if (CanAccommodateOccupancy(datesAndAccupancy().adultes, datesAndAccupancy().children, bestPrice().code_occupancy, bestPrice().code_children)) {
            <tui-icon icon="/assets/svg/ok.svg" class="ok"></tui-icon>
        }
        @else {
            <tui-icon 
                background="@tui.triangle-alert" class="warning"
                tuiHintAppearance="error"
                tuiHintDirection="right"
                [tuiHint]="tooltip"
            />
        }
        <ng-template #tooltip>
            {{'youwillneedmorethanaroomofthiskindtosatisfyyoursearchcriteria($x1adults+$x2child)'| customTranslate: {val1: datesAndAccupancy().adultes, val2: datesAndAccupancy().children} }}
        </ng-template>
    </div>
</div>